<template>
  <VUEModal v-if="Popup" :Titolo="'Seleziona il colore desiderato'" :Programma="Programma" :Altezza="'400px'" :Larghezza="'500px'"
            @onClickChiudiModal="ChiudiPopup" @onClickConfermaModal="ConfermaPopup">
    <template v-slot:Body>
      <ColorPicker :color="Colore.Colore" :visibleFormats="['rgb']" :alphaChannel="'show'" @color-change="CambiaColore"></ColorPicker>
    </template>
  </VUEModal>
</template>

<script>

// Versione 1.0.0 - 09 Novembre 2023 - Francesco Ardini
//                - Prima Versione

import VUEModal from './/VUEModal.vue';
// Per utilizzare il popup è necessario installare il ColorPicker
// npm install vue-accessible-color-picker
import { ColorPicker } from 'vue-accessible-color-picker'

export default 
{
  data()
  {
   return {
          }
  },
  props : ['Colore', 'Popup', 'Programma'],
  emits : ['OnClickChiudiPopup', 'OnClickConfermaPopup'],
  components: { VUEModal, ColorPicker },
  methods :
  {
    ConfermaPopup()
    {
      this.$emit('OnClickConfermaPopup')
    },
    ChiudiPopup()
    {
      this.$emit('OnClickChiudiPopup')
    },
    CambiaColore(NuovoColore)
    {
      this.ColoreChange.Colore = NuovoColore.cssColor
    }
  },
  computed:
  {
    ColoreChange:
    {
      get()
      {
        return this.Colore
      }
    }
  },
  beforeMount()
  {

  }
}
</script>
